import { SITE } from "@/constants/site";
import useI18n from "@/i18n";

/** Horaires d'ouverture, strictement identiques à la fiche Google. */
export default function Horaires({ compact = false }) {
    const { t } = useI18n();

    if (compact) {
        return (
            <p className="text-ink2" data-testid="horaires-compact">
                <span className="font-semibold text-ink">{t.hours.compactStrong}</span>{" "}
                {t.hours.compactRest}
            </p>
        );
    }

    return (
        <ul data-testid="horaires-liste">
            {SITE.hours.map(([, plage], i) => (
                <li
                    key={t.hours.days[i]}
                    className="flex items-baseline justify-between gap-4 border-b py-2.5 last:border-0"
                    style={{ borderColor: "var(--c-line)" }}
                    data-testid={`horaire-day-${i}`}
                >
                    <span className={plage ? "font-semibold" : "text-ink2"}>
                        {t.hours.days[i]}
                    </span>
                    <span
                        className={
                            plage ? "whitespace-nowrap font-bold text-terrat" : "text-sm text-ink2"
                        }
                    >
                        {plage ? t.hours.range : t.common.closed}
                    </span>
                </li>
            ))}
        </ul>
    );
}
